import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { uptimeSelector } from '../selectors/dashboardSelector';
import { getUptimeRequest } from '../actions/dashboardActions';
import ActivityTime from '../components/ActivityTime/ActivityTime';

const mapStateToProps = createStructuredSelector({ uptime: uptimeSelector });
const mapDispatchToProps = { getUptimeRequest };

export default connect(mapStateToProps, mapDispatchToProps)(ActivityTime);
